module.exports = __webpack_public_path__ + "img/feather-alt.192ff2d5.svg";